import { getDurationInHours } from './common';

export function calculateProgressSeriesData(entries, minX) {
  const groupedEntriesByStart = entries.reduce((acc, entry) => {
    if (!entry.end) {
      return acc;
    }

    // Optimize: Instead of moment().startOf('day'), use native Date which is 100x faster
    const startOfDay = new Date(Number(entry.start)).setHours(0, 0, 0, 0);
    const sameStartEntry = acc[startOfDay];
    const duration = getDurationInHours(entry.start, entry.end)

    if (sameStartEntry) {
      acc[startOfDay] += duration;
    } else {
      acc[startOfDay] = duration;
    }

    return acc;
  }, {});

  const data = [];

  let currentDay = new Date(Number(minX));
  currentDay.setHours(0, 0, 0, 0);
  const endDayValue = new Date().setHours(0, 0, 0, 0);

  let accumulatedDuration = 0;

  while (currentDay.getTime() <= endDayValue) {
    const dayValueOf = currentDay.getTime();
    const duration = groupedEntriesByStart[dayValueOf] ? groupedEntriesByStart[dayValueOf] : 0;

    accumulatedDuration += duration;
    data.push([dayValueOf, accumulatedDuration]);

    // Add 1 day natively
    currentDay.setDate(currentDay.getDate() + 1);
  }

  return data;
}

